// Updated AddFilter.js component
import React from 'react';
import { Button, Select, Space } from 'antd';
import { PlusOutlined } from '@ant-design/icons';

const AddFilter = ({ availableFilters, onAddFilter }) => {
    const [isSelecting, setIsSelecting] = React.useState(false);

    const handleSelect = (filterId) => {
        onAddFilter(filterId);
        setIsSelecting(false);
    };

    if (isSelecting) {
        return (
            <Space>
                <Select
                    open={true} // Force the dropdown to open immediately
                    style={{
                        width: 200,
                        borderRadius: '20px',
                    }}
                    dropdownStyle={{
                        borderRadius: '12px',
                    }}
                    placeholder="Select a filter"
                    onChange={handleSelect}
                    onBlur={() => setIsSelecting(false)}
                    autoFocus
                    showSearch
                    filterOption={(input, option) =>
                        (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                    }
                    options={availableFilters.map(filter => ({
                        label: filter.title,
                        value: filter.id
                    }))}
                />
            </Space>
        );
    }

    return (
        <div style={{
            display: 'inline-flex',
            alignItems: 'center',
            height: '32px' // Match the height of the filter pills for vertical alignment
        }}>
            <Button
                type="link"
                icon={<PlusOutlined />}
                style={{
                    paddingLeft: 0,
                    display: 'flex',
                    alignItems: 'center',
                    height: '100%'
                }}
                onClick={() => setIsSelecting(true)}
            >
                Add filter
            </Button>
        </div>
    );
};

export default AddFilter;
